import React from 'react';
import ASCIILoader from 'js/components/elements/ASCIILoader';
import { ERROR_MESSAGES } from '../../constants';
import s from '../../FlowRunLogs.module.scss';
import { Stack } from '@mui/material';

type LogListHeaderProps = {
  showReachedEndMessage?: boolean;
  loading?: boolean;
};

export const LogListHeader: React.FC<LogListHeaderProps> = ({
  showReachedEndMessage = false,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className={s.asciiLoader}>
        <ASCIILoader />
      </div>
    );
  }

  if (!showReachedEndMessage) return <Stack height={24} />;

  const msg = ERROR_MESSAGES.REACHED_END;
  return (
    <div className={s.noMoreLogsText}>
      <span className={s.greyscale400Text}>{msg}</span>
    </div>
  );
};
